import { IThemeParams } from '@dtos/Theme'
import { IThemeSeed } from './buildTheme'

const VIIH_TUBE_SEED: IThemeSeed = {
  background: '#0B050B',
  surface: '#1A0614',
  border: '#5A1037',
  text: '#FFFFFF',
  accent: '#E86FB0',
  cta: '#F3AFD1',
  overrides: { 'progress-complete': '#E86FB0' },
}

/**
 * Temas por escola enquanto a configuração não vem da API. Chave: `school.id`.
 * Escola fora daqui fica no tema default.
 */
export const SCHOOL_THEME_SEEDS: Record<string, IThemeSeed> = {
  844901: VIIH_TUBE_SEED,
}

export function resolveSchoolThemeSeed(
  schoolId: number | string | null | undefined,
  registry: Record<string, IThemeSeed> = SCHOOL_THEME_SEEDS,
): IThemeSeed | null {
  if (schoolId === undefined || schoolId === null) return null

  return registry[String(schoolId)] ?? null
}

export function resolveThemeSeed(
  params: IThemeParams | null | undefined,
  registry: Record<string, IThemeSeed> = SCHOOL_THEME_SEEDS,
): IThemeSeed | null {
  return resolveSchoolThemeSeed(params?.school?.id, registry)
}
